<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    <v-container>
      <template v-if="transmission">
        <v-row>
          <v-col cols="3">
            <display-field
              label="HUB site"
            >
              <div
                v-bind:class="{ hub: transmission.hub_site_name === 'Yes'}"
              >
                {{ transmission.hub_site_name }}
              </div>
            </display-field>
          </v-col>
        </v-row>
      </template>
      <h2>Air conditioning</h2>
        <air-conditioning :site="site"></air-conditioning>
      <h2>DC system</h2>
        <d-c-system :site="site"></d-c-system>
      <h2>Battery</h2>
        <battery :site="site"></battery>
      <h2>Shelter</h2>
        <shelter :site="site"></shelter>
      <h2>Tower</h2>
        <tower :site="site"></tower>
    </v-container>
  </permissions-view>
</template>

<script>
  import DisplayField from '@/components/DisplayField'
  import FormActions from '@/components/FormActions'
  import AirConditioning from '@/views/sites/sections/construction-equipment/AirConditioning'
  import DCSystem from '@/views/sites/sections/construction-equipment/DCSystem'
  import Battery from '@/views/sites/sections/construction-equipment/Battery'
  import PermissionsView from '@/components/PermissionsView'
  import SiteTransmissionService from '@/services/site-transmission'
  import ReactivityMixin from '@/mixins/Reactivity'
  import Shelter from '@/views/sites/sections/construction-equipment/Shelter'
  import Tower from '@/views/sites/sections/construction-equipment/Tower'

  export default {
    name: 'ConstructionEquipment',
    mixins: [
      ReactivityMixin,
    ],
    components: { Tower, Shelter, PermissionsView, Battery, DCSystem, AirConditioning, FormActions, DisplayField },
    props: {
      site: {
        default: null,
      },
      active: {
        default: false,
      },
    },
    data: () => ({
      loading: false,
      saved: false,
      transmission: undefined,
      section: 'construction_equipment',
    }),
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const sts = new SiteTransmissionService(this.site.id)
        sts.getSingle().then((response) => {
          this.transmission = response.data.data
        })
      },
      saveData () {

      },
    },
  }
</script>

<style scoped>

.hub {
  color: white;
  font-weight: bold;
  border-radius: 5px;
  background-color: red;
  padding: 10px 1px 10px 1px;
  text-align: center;
}

</style>
